/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Facility } from '@app/settings/facilities/facilities.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class FacilitiesService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/facilities', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((facility: any) => {
          return new Facility().deserialize(facility);
        });

        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(facility: Facility): Observable<Facility> {
    return this.http.put('v1/facilities/' + facility.id, facility).pipe(
      map((response: HttpResponse) => {
        return new Facility().deserialize(response.data);
      })
    );
  }

  store(facility: Facility): Observable<Facility> {
    return this.http.post('v1/facilities', facility).pipe(
      map((response: HttpResponse) => {
        return new Facility().deserialize(response.data);
      })
    );
  }

  show(id: number): Observable<Model> {
    return this.http.get('v1/facilities/' + id).pipe(
      map((response: HttpResponse) => {
        return new Facility().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/facilities/' + id);
  }
}
